export default __webpack_public_path__ + "static/media/682.6a861f62.jpg";